import { cn } from "@theprelude/core";

export const TagIcon: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.26661 1.40039L13.8659 2.34372L14.8086 8.94372L8.68061 15.0717C8.55559 15.1967 8.38605 15.2669 8.20927 15.2669C8.0325 15.2669 7.86296 15.1967 7.73794 15.0717L1.13794 8.47172C1.01296 8.34671 0.942749 8.17717 0.942749 8.00039C0.942749 7.82361 1.01296 7.65408 1.13794 7.52906L7.26661 1.40039ZM7.73794 2.81506L2.55194 8.00039L8.20927 13.6571L13.3946 8.47172L12.6879 3.52172L7.73794 2.81506V2.81506ZM9.15127 7.05772C8.90117 6.80754 8.7607 6.46824 8.76077 6.11449C8.7608 5.93933 8.79533 5.76589 8.86239 5.60407C8.92945 5.44225 9.02773 5.29523 9.15161 5.17139C9.27549 5.04755 9.42255 4.94933 9.58439 4.88233C9.74623 4.81532 9.91968 4.78085 10.0948 4.78089C10.4486 4.78095 10.7878 4.92154 11.0379 5.17172C11.288 5.42191 11.4285 5.7612 11.4284 6.11496C11.4284 6.46872 11.2878 6.80796 11.0376 7.05806C10.7874 7.30816 10.4481 7.44863 10.0944 7.44856C9.74061 7.4485 9.40137 7.30791 9.15127 7.05772V7.05772Z" />
  </svg>
);
